import { useState } from "react";
import { useLocation } from "react-router-dom";
import { hasFolderParam } from "../utils/sharepointLinks";

/**
 * Tab state for a page with a "documents" tab. It starts on that tab when the
 * URL deep-links a folder, so links from a file preview land on the browser.
 */
function useDocumentsTab(defaultTab: string) {
	const location = useLocation();
	return useState<string>(() =>
		hasFolderParam(location.search) ? "documents" : defaultTab
	);
}

export default useDocumentsTab;
